<template>
  <div>
    <el-form :inline="true" :model="queryParam" class="demo-form-inline" size="mini">
      <el-form-item label="订单时间 ：">
        <el-col :span="11">
          <el-date-picker type="date" placeholder="选择日期" v-model="queryParam.beginTime" style="width: 100%;" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-col>
        <el-col class="line" style="text-align:center;" :span="2">-</el-col>
        <el-col :span="11">
          <el-date-picker type="date" placeholder="选择日期" v-model="queryParam.endTime" style="width: 100%;" value-format="yyyy-MM-dd 23:59:59"></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item label="订单号 ：">
        <el-input v-model="queryParam.orderSn" placeholder="订单号"></el-input>
      </el-form-item>
      <el-form-item label="ISBN ：">
        <el-input v-model="queryParam.isbn" placeholder="ISBN"></el-input>
      </el-form-item>
      <el-form-item label="收件人 ：">
        <el-input v-model="queryParam.consignee" placeholder="收件人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话 ：">
        <el-input v-model="queryParam.tel" placeholder="联系电话"></el-input>
      </el-form-item>
      <el-form-item label="有备注 ：" style="margin: 0 40px;">
        <el-checkbox v-model="queryParam.haveRemarkFlag">有</el-checkbox>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit" icon="el-icon-search">查询</el-button>
        <el-button type="success" @click="exportExcels" icon="el-icon-download">导出</el-button>
        <!-- <el-button type="success" @click="exportFkGysExcels" icon="el-icon-download">分开供应商导出</el-button> -->
      </el-form-item>
    </el-form>
    <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
      <el-tab-pane label="已完成订单" name="2">
        <wh-order-complete ref="orderComplete" @selectionChange="selectionChange"></wh-order-complete>
      </el-tab-pane>
      <el-tab-pane label="待付款订单" name="3">
        <wh-order-no-pay ref="orderNoPay" @selectionChange="selectionChange"></wh-order-no-pay>
      </el-tab-pane>
      <el-tab-pane label="已取消订单" name="4">
        <wh-order-cancel ref="orderCancel" @selectionChange="selectionChange"></wh-order-cancel>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { downFile } from "../../api/index";
import whOrderNoPay from "./whMyOrder/whOrderNoPay";
import whOrderComplete from "./whMyOrder/whOrderComplete";
import whOrderCancel from "./whMyOrder/whOrderCancel";
export default {
  name: "whOrderMain",
  provide() {
    return {
      parentQueryParam: this.queryParam
    }
  },
  data() {
    return {
      tableData: [],
      textarea: "",
      ids: "",
      orderId: "",
      activeName: "1",
      isdefault: false,
      queryParam: {
        isbn: "",
        orderSn: "",
        beginTime: "",
        endTime: "",
      },
      url: {
        getorderLit: "/whOrder/queryList",
        exportExcel: "/whOrder/exportExcel",
        exportExcels: "/wrhOrde/exportExcels",
        exportFkGysExcels: "/whOrder/exportFkGysExcelsToZip",
      },
    };
  },
  components: {
    whOrderNoPay,
    whOrderComplete,
    whOrderCancel,
  },
  mounted() {},
  computed: {
    ...mapGetters(["isNaName"]),
  },
  created() {
    console.log("this.$route.params :>> ", this.$route.params);
    this.activeName = this.$route.params.flag;
  },
  methods: {
    handleClick() {
      let isbn = this.queryParam.isbn;
      let orderSn = this.queryParam.orderSn;
      let createTime_begin = this.queryParam.beginTime;
      let createTime_end = this.queryParam.endTime;
      let consignee = this.queryParam.consignee;
      let tel = this.queryParam.tel;
      let haveRemarkFlag = this.queryParam.haveRemarkFlag;
      // if (this.activeName === "1" && this.$refs.orderOn.getOrderList) {
        // this.$refs.orderOn.getOrderList(1,
        //   isbn,
        //   orderSn,
        //   createTime_begin,
        //   createTime_end, consignee, tel, haveRemarkFlag);
      // }else 
      if (this.activeName === "2" && this.$refs.orderComplete.getOrderList) {
        this.$refs.orderComplete.getOrderList(1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag);
      }else if (this.activeName === "3" && this.$refs.orderNoPay.getOrderList) {
        this.$refs.orderNoPay.getOrderList(1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag);
      }else if (this.activeName === "4" && this.$refs.orderCancel.getOrderList) {
        this.$refs.orderCancel.getOrderList(1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag);
      }
    },
    onSubmit() {
      let isbn = this.queryParam.isbn;
      let orderSn = this.queryParam.orderSn;
      let createTime_begin = this.queryParam.beginTime;
      let createTime_end = this.queryParam.endTime;
      let consignee = this.queryParam.consignee;
      let tel = this.queryParam.tel;
      let haveRemarkFlag = this.queryParam.haveRemarkFlag;
      console.log("createTime_end=============", createTime_end);
      // if (this.activeName === "1") {
      //   this.$refs.orderOn.getOrderList(
      //     1,
      //     isbn,
      //     orderSn,
      //     createTime_begin,
      //     createTime_end, consignee, tel, haveRemarkFlag
      //   );
      // }
      if (this.activeName === "2") {
        this.$refs.orderComplete.getOrderList(
          1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag
        );
      }
      if (this.activeName === "3") {
        this.$refs.orderNoPay.getOrderList(
          1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag
        );
      }
      if (this.activeName === "4") {
        this.$refs.orderCancel.getOrderList(
          1,
          isbn,
          orderSn,
          createTime_begin,
          createTime_end, consignee, tel, haveRemarkFlag
        );
      }
    },
    selectionChange(data){
      this.ids="";
      if (data.length>0) {
          for (var i = 0; i < data.length; i++) {
              this.ids = this.ids + data[i].orderSn + ","
          }
      }
    },
    exportFkGysExcels(){
      const that = this
      let fileName = this.$store.state.userInfo.warehouseName + '订单';
      if (that.ids!=""){
        that.orderId=that.ids
      }else {
        that.orderId=that.queryParam.orderSn
      }
      downFile(that.url.exportFkGysExcels, {
        whUId: that.$store.state.userInfo.id,
        isbn : that.queryParam.isbn,
        orderSn : that.orderId,
        createTime_begin : that.queryParam.beginTime,
        createTime_end : that.queryParam.endTime,
        consignee: that.queryParam.consignee,
        tel: that.queryParam.tel,
        haveRemarkFlag: that.queryParam.haveRemarkFlag,
      }).then((data) => {
        // console.log("data :>> ", data);
        if (!data) {
          that.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(new Blob([data.data], { type: "application/vnd.ms-excel" }), fileName + ".xls");
        } else {
          let url = window.URL.createObjectURL(new Blob([data.data], { type: "application/vnd.ms-excel" }));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    exportExcels() {
      const that = this
      let fileName = this.$store.state.userInfo.warehouseName + '订单';
      if (that.ids!=""){
        that.orderId=that.ids
      }else {
        that.orderId=that.queryParam.orderSn
      }
      downFile(that.url.exportExcels, {
        whUId: that.$store.state.userInfo.id,
        isbn : that.queryParam.isbn,
        orderSn : that.orderId,
        createTime_begin : that.queryParam.beginTime,
        createTime_end : that.queryParam.endTime,
        consignee: that.queryParam.consignee,
        tel: that.queryParam.tel,
        haveRemarkFlag: this.queryParam.haveRemarkFlag,
      }).then((data) => {
        // console.log("data :>> ", data);
        if (!data) {
          that.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(new Blob([data.data], { type: "application/vnd.ms-excel" }), fileName + ".xls");
        } else {
          let url = window.URL.createObjectURL(new Blob([data.data], { type: "application/vnd.ms-excel" }));
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
    exportExcel() {
      let fileName = this.$store.state.userInfo.warehouseName + '订单';
      downFile(this.url.exportExcel, {
        userId: this.$store.state.userInfo.id,
      }).then((data) => {
        console.log("data :>> ", data);
        if (!data) {
          this.$message.warning("文件下载失败");
          return;
        }
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([data.data], { type: "application/vnd.ms-excel" }),
            fileName + ".xls"
          );
        } else {
          let url = window.URL.createObjectURL(
            new Blob([data.data], { type: "application/vnd.ms-excel" })
          );
          let link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName + ".xls");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); //下载完成移除元素
          window.URL.revokeObjectURL(url); //释放掉blob对象
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
  margin-top: 1%;
  font-size: 14px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.bg-purple-light {
  line-height: 36px;
}
.el-cascader {
  display: block;
}
</style>
